export default "__VITE_ASSET__DgsMNzbP__"